module.exports = __webpack_public_path__ + "static/media/mkidn-logo.7ea6de12.webp";